import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./authForm.css";
import { validateAuthForm } from "../../utils/validations";
import { authUser } from "../../features/auth/authThunks";
import { cleanBackendErrors } from "../../features/auth/authSlice";

export const FormAuth = ({ title, endPoint, fields, buttonName }) => {
    const nav = useNavigate();
    const dispatch = useDispatch();
    const { loading, backendAuthErrors } = useSelector((state) => state.auth);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordC, setShowPasswordC] = useState(false);
    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
        passwordC: ""
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(cleanBackendErrors());
    }, [])


    const handleChange = (e) => {
        const { name, value } = e.target;

        const updatedForm = { ...form, [name]: value };
        const updatedErrors = { ...errors, [name]: "" };

        if (name === "email") {
            updatedErrors.emailFormat = ""
        }

        setForm(updatedForm);
        setErrors(updatedErrors);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();


        const formErrors = validateAuthForm(form, endPoint);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            console.log(errors);
            return;
        }
        console.log("SUBMITTING...");

        try {
            const result = await dispatch(authUser({ form, endPoint })).unwrap();
            nav("/home");
        } catch (error) {
            console.error("Error during authentication", error);
        }
    };

    const handleChangePassword = (e) => {
        e.preventDefault();
        setShowPassword(!showPassword);
    };

    const handleChangePasswordC = (e) => {
        e.preventDefault();
        setShowPasswordC(!showPasswordC);
    };

    return (
        <>
            <div className="authForm-header-div">
                <h2>SHOP.CO</h2>
            </div>
            <div className="authForm-card">
                <form className="authForm-form" onSubmit={handleSubmit}>
                    <h2 className="authForm-title">{title}</h2>
                    <div className="authForm-div-form">
                        {fields.includes("userName") && (
                            <>
                                <label className="authForm-label" htmlFor="userName">User Name:</label>
                                <input
                                    className={`authForm-input ${errors?.name ? "error" : ""}`}
                                    id="userName"
                                    name="name"
                                    placeholder="Enter your name ..."
                                    onChange={handleChange}
                                />

                            </>
                        )}

                        {fields.includes("email") && (
                            <>
                                <label className="authForm-label" htmlFor="email">Email:</label>
                                <input
                                    className={`authForm-input ${(errors?.email || errors?.emailFormat || backendAuthErrors.email || backendAuthErrors?.password) ? "error" : ""}`}
                                    id="email"
                                    name="email"
                                    placeholder="Enter your email ..."
                                    onChange={handleChange}
                                />
                                {errors?.emailFormat && <p className="authForm-error">{errors?.emailFormat}</p>}
                                {backendAuthErrors?.email && <p className="authForm-error">{backendAuthErrors.email}</p>}
                            </>
                        )}

                        {fields.includes("password") && (
                            <>
                                <label className="authForm-label" htmlFor="password">Password:</label>
                                <div className="authForm-div-password">
                                    <input
                                        className={`authForm-input ${(errors?.password || errors?.passwordCMatch || errors.passwordReq || backendAuthErrors?.password) ? "error" : ""}`}
                                        id="password"
                                        name="password"
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Enter your password ..."
                                        onChange={handleChange}
                                    />
                                    <button
                                        type="button"
                                        className="authForm-showButton"
                                        onClick={handleChangePassword}>
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                    </button>
                                </div>
                                {errors?.passwordReq && <p className="authForm-error">{errors.passwordReq}</p>}
                                {backendAuthErrors?.password && <p className="authForm-error">{backendAuthErrors.password}</p>}


                            </>
                        )}

                        {fields.includes("passwordC") && (
                            <>
                                <label className="authForm-label" htmlFor="passwordC">Confirm Password:</label>
                                <div className="authForm-div-password">
                                    <input
                                        className={`authForm-input ${(errors?.passwordC || errors?.passwordCMatch) ? "error" : ""}`}
                                        id="passwordC"
                                        name="passwordC"
                                        type={showPasswordC ? "text" : "password"}
                                        placeholder="Confirm your password ..."
                                        onChange={handleChange}
                                    />
                                    <button
                                        type="button"
                                        className="authForm-showButton"
                                        onClick={handleChangePasswordC}>
                                        <FontAwesomeIcon icon={showPasswordC ? faEyeSlash : faEye} />
                                    </button>
                                </div>
                                {errors?.passwordCMatch && <p className="authForm-error">{errors?.passwordCMatch}</p>}
                            </>
                        )}
                    </div>

                    <div className="authForm-div-button">
                        <button className="authForm-button" type="submit" disabled={loading} >
                            {loading ? <div className="loading-spinner"></div> : buttonName}
                        </button>
                    </div>
                    <div className="authForm-toggle">
                        {endPoint === "login" ? (
                            <p className="authForm-paragraph-bottom">
                                Don't have an account? <Link to="/signup" className="authForm">Create account</Link>
                            </p>
                        ) : (
                            <p className="authForm-paragraph-bottom">
                                Already have an account? <Link to="/login" className="authForm">Login now</Link>
                            </p>
                        )}
                    </div>
                </form>
            </div>
        </>
    );
};
